module.exports = "/assets/cab830a2a4f60e141ea58ba73c23f7b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/RG.png
// module id = 2908
// module chunks = 0